export default "__VITE_ASSET__IZytd8TX__"